module.exports = __webpack_public_path__ + "assets/0292d05799339ad6c2dfedfae5af4b70.png";